module.exports = __webpack_public_path__ + "static/media/Item 3.41e1a647.jpg";